import React from "react";

import { ChangableVehicleTemplate } from "../../facades/VehicleTemplate";

import TemplateEditor from "../templateEditor/TemplateEditor";

type EditingTabProps = {
  template: ChangableVehicleTemplate;
  onChangeTemplate: (template: Partial<ChangableVehicleTemplate>) => void;
};

const EditingTab: React.FC<EditingTabProps> = ({
  template,
  onChangeTemplate,
}) => <TemplateEditor template={template} setTemplate={onChangeTemplate} />;

export default EditingTab;
